import { Link } from "react-router-dom";
import { categoryList } from "@/mocks/banners";

export default function CategoryQuickEntry() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6 md:gap-4">
      {categoryList.map((c, i) => (
        <Link
          key={c.key}
          to={`/category/${c.key}`}
          className="group flex flex-col items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 px-4 py-6 text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer rf-fade-up"
          style={{ animationDelay: `${i * 50}ms` }}
        >
          <span className="flex h-14 w-14 items-center justify-center rounded-lg bg-primary-50 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
            <i className={`${c.icon} text-2xl`}></i>
          </span>
          <span className="font-heading text-sm font-bold text-foreground-950">
            {c.name}
          </span>
          <span className="text-[11px] uppercase tracking-wide text-foreground-400">
            {c.en}
          </span>
        </Link>
      ))}
    </div>
  );
}